// UploadSlides.jsx
import React, { useState, useEffect } from "react";
import SlideGrid from "./SlideGrid";
import SlideForm from "./SlideFrom";

const LOCAL_STORAGE_KEY = "slidesData";

const UploadSlides = () => {
  const [slides, setSlides] = useState([]);
  const [view, setView] = useState("grid");
  const [currentSlide, setCurrentSlide] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved) {
      setSlides(JSON.parse(saved));
    } else {
      setSlides([
      
      ]);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(slides));
  }, [slides]);

  const handleEdit = (slide) => {
    setCurrentSlide(slide);
    setView("form");
  };

  const handleCreate = () => {
    setCurrentSlide({ id: Date.now(), label: "", image: null });
    setView("form");
  };

  const handleDelete = (id) => {
    setSlides((prev) => prev.filter((s) => s.id !== id));
  };

  const handleSave = (slide) => {
    setSlides((prev) => {
      const exists = prev.find((s) => s.id === slide.id);
      if (exists) {
        return prev.map((s) => (s.id === slide.id ? slide : s));
      } else {
        return [...prev, slide];
      }
    });
    setView("grid");
    setCurrentSlide(null);
  };

  const handleCancel = () => {
    setView("grid");
    setCurrentSlide(null);
  };

  const handleClearAll = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
    setSlides([]);
  };

  return (
    <div className="container mt-4">
      {view === "grid" ? (
        <SlideGrid
          slides={slides}
          onEdit={handleEdit}
          onCreate={handleCreate}
          onDelete={handleDelete}
          onClearAll={handleClearAll}
        />
      ) : (
        <SlideForm
          slide={currentSlide}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
};

export default UploadSlides;
